import { combineReducers } from 'redux'
import type { AliasMetadataState } from './entities/alias-metadata'
import { aliasMetadataReducer as aliasMetadata } from './entities/alias-metadata'
import type { BusinessInvitesState } from './entities/businessInvites'
import { businessInvitesReducer as businessInvites } from './entities/businessInvites'
import type { BusinessUsersState } from './entities/businessUsers'
import { businessUsersReducer as businessUsers } from './entities/businessUsers'
import type { State as ContactsState } from './entities/contacts'
import { contactsReducer as contacts } from './entities/contacts'
import type { State as ContactsAllState } from './entities/contactsAll'
import { contactsAllReducer as contactsAll } from './entities/contactsAll'
import type { EmailCampaignsState } from './entities/emailCampaigns'
import { emailCampaignsReducer as emailCampaigns } from './entities/emailCampaigns'
import type { NativeCategoriesState } from './entities/nativeCategories'
import { nativeCategoriesReducer as nativeCategories } from './entities/nativeCategories'
import type { NativeTagsState } from './entities/nativeTags'
import { nativeTagsReducer as nativeTags } from './entities/nativeTags'
import type { PlaylistSharesState } from './entities/playlistShares'
import type { TrackSharesState } from './entities/trackShares'
import { trackSharesReducer as trackShares } from './entities/trackShares'
import { playlistSharesReducer as playlistShares } from './entities/playlistShares'
import type { PlaylistTagsState } from './entities/playlistTags'
import { playlistTagsReducer as playlistTags } from './entities/playlistTags'
import type { PlaylistTypesState } from './entities/playlistTypes'
import { playlistTypesReducer as playlistTypes } from './entities/playlistTypes'
import type { ProState } from './entities/pro'
import { proReducer as pro } from './entities/pro'
import { labelReducer as labels } from './entities/labels'
import { rightsholderReducer as rightsholders } from './entities/rightsholders'
import type { PublishersState } from './entities/publishers'
import { publishersReducer as publishers } from './entities/publishers'
import type { State as TagsState } from './entities/tags'
import { tagsReducer as tags } from './entities/tags'
import type { BriefsState } from './entities/briefs'
import { briefsReducer as briefs } from './entities/briefs'
import type { BriefProjectsState } from './entities/briefProjects'
import { briefProjectsReducer as briefProjects } from './entities/briefProjects'
import type { BriefNotesState } from './entities/briefNotes'
import { briefNotesReducer as briefNotes } from './entities/briefNotes'
export type EntitiesState = {
  playlistTags: PlaylistTagsState
  playlistTypes: PlaylistTypesState
  playlistShares: PlaylistSharesState
  trackShares: TrackSharesState
  aliasMetadata: AliasMetadataState
  tags: TagsState
  nativeCategories: NativeCategoriesState
  nativeTags: NativeTagsState
  contacts: ContactsState
  contactsAll: ContactsAllState
  pro: ProState
  businessInvites: BusinessInvitesState
  businessUsers: BusinessUsersState
  publishers: PublishersState
  emailCampaigns: EmailCampaignsState
  briefs: BriefsState
  briefProjects: BriefProjectsState
  briefNotes: BriefNotesState
}
export const entitiesReducer = combineReducers({
  briefs,
  briefProjects,
  briefNotes,
  playlistTags,
  playlistTypes,
  playlistShares,
  trackShares,
  aliasMetadata,
  tags,
  nativeCategories,
  nativeTags,
  contacts,
  contactsAll,
  pro,
  labels,
  rightsholders,
  businessInvites,
  businessUsers,
  publishers,
  emailCampaigns,
})
